/* istanbul ignore file */

/**
 * See unified (?) Yle News Lab Colors:
 * - https://www.figma.com/file/wQxLoponMcSViZy5xkbYUP/Ukko-style-guide?node-id=7%3A0
 * - https://ukko.test.yle.fi/storybook/?path=/story/fundamentals-colors--color-palette
 */

export const BLACK = '#110f24'
export const WHITE = '#ffffff'
export const LIVE_PINK = '#DF1663'

export const colorTones = {
  normal: 'normal',
  light: 'light',
  lighter: 'lighter',
  dark: 'dark',
  darker: 'darker'
}

export type ColorName =
  | 'black'
  | 'brown'
  | 'blue'
  | 'green'
  | 'grey'
  | 'purple'
  | 'red'
  | 'turquoise'
  | 'white'
  | 'yellow'

export type Color = {
  normal: string
  dark: string
  darker: string
  light: string
  lighter: string
  contrast: string
}

export const palette: Record<ColorName, Color> & { background: string } = {
  black: {
    normal: BLACK,
    dark: BLACK,
    darker: BLACK,
    light: BLACK,
    lighter: BLACK,
    contrast: WHITE
  },
  white: {
    normal: WHITE,
    dark: WHITE,
    darker: WHITE,
    light: WHITE,
    lighter: WHITE,
    contrast: BLACK
  },
  grey: {
    normal: '#d3d7da',
    dark: '#3b3e48',
    darker: BLACK,
    light: '#edf0f3',
    lighter: '#f6f6f9',
    contrast: WHITE
  },
  turquoise: {
    normal: '#05bdd0',
    dark: '#03a0c1',
    darker: '#146b94',
    light: '#6fdde7',
    lighter: '#d8f2f1',
    contrast: WHITE
  },
  blue: {
    normal: '#2b7ac8',
    dark: '#1c5b98',
    darker: '#0c3a66',
    light: '#4ba6ff',
    lighter: '#bbdeff',
    contrast: WHITE
  },
  purple: {
    normal: '#6750A4',
    dark: '#21005D',
    darker: '#381E72',
    light: '#8879fc',
    lighter: '#cac4ff',
    contrast: WHITE
  },
  red: {
    normal: '#B3261E',
    dark: '#a30d43',
    darker: '#59091a',
    light: '#e95c7b',
    lighter: '#ffcfd9',
    contrast: WHITE
  },
  green: {
    normal: '#007C33',
    dark: '#3B873E',
    darker: '#0a4423',
    light: '#5dc389',
    lighter: '#bbf6d4',
    contrast: WHITE
  },
  yellow: {
    normal: '#ffc107',
    dark: '#b38327',
    darker: '#8e6403',
    light: '#ffcf74',
    lighter: '#ffe4af',
    contrast: WHITE
  },
  brown: {
    normal: '#7D5260',
    dark: '#55313C',
    darker: '#4E1C2C',
    light: '#9D7280',
    lighter: '#C29FAB',
    contrast: WHITE
  },
  background: '#F3EDF7'
}
